// extracted by mini-css-extract-plugin
export default {"root":"VrtLkKJuI8fBRa9yrDY5"};